import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaArrowRight, FaCheck } from "react-icons/fa";
import { SectionHeader, Reveal } from "../../../components/common";

const STEPS = [
  { title: "Tell us about your project", desc: "One email with your goals, timeline and budget range." },
  { title: "Get a tailored proposal", desc: "Scoped package with clear pricing, usually within 48 hours." },
  { title: "Kick off and launch", desc: "We design, build and ship while you stay in the loop." },
];

const PackageSection = () => {
  return (
    <section id="pricing-section" className="bleed bg-[#FBFAF9] border-y border-designer-dark/10">
      <div className="container-responsive py-16 md:py-24">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-14 lg:items-center">
          <div>
            <SectionHeader
              index="05"
              eyebrow="Packages & pricing"
              title={<>No fixed price list. Every quote is built around your goals.</>}
              lede="Retainers, one-off brand kits or full launches. Tell us where you want to be visible and we'll scope the fastest route there."
              layout="stacked"
            />
            <Reveal delay={200}>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <a
                  href="mailto:arvixcreative@gmail.com?subject=Package Information Inquiry"
                  className="group inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-designer-primary text-white font-semibold text-sm rounded-full hover:bg-red-700 transition-colors"
                >
                  <FaEnvelope className="w-4 h-4" />
                  arvixcreative@gmail.com
                </a>
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center gap-2 px-7 py-3.5 font-semibold text-sm text-designer-dark border border-designer-dark/20 rounded-full hover:border-designer-primary hover:text-designer-primary transition-colors"
                >
                  Contact page
                  <FaArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            </Reveal>
          </div>

          <Reveal delay={140}>
            <ol className="bg-white rounded-3xl border border-designer-dark/10 p-6 sm:p-8 shadow-[0_24px_60px_-30px_rgba(29,32,48,0.3)] space-y-2">
              {STEPS.map((step, i) => (
                <li key={step.title} className="flex gap-4 py-4 first:pt-0 last:pb-0 border-b border-designer-dark/[0.07] last:border-0">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-designer-primary/10 text-designer-primary font-display font-bold text-sm">
                    {i + 1}
                  </span>
                  <span>
                    <span className="block font-bold text-designer-dark">{step.title}</span>
                    <span className="mt-0.5 block text-sm text-gray-500 leading-relaxed">{step.desc}</span>
                  </span>
                </li>
              ))}
              <li className="pt-4 flex items-start gap-2.5 text-[13px] text-gray-500">
                <FaCheck className="mt-0.5 w-3.5 h-3.5 text-emerald-500 shrink-0" />
                No commitment needed: the first consultation call is always free.
              </li>
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default PackageSection;
